import { render } from "./ButtonEditSubmit.vue?vue&type=template&id=34de790a"
import script from "./ButtonEditSubmit.vue?vue&type=script&lang=js"
export * from "./ButtonEditSubmit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__